import React, { FunctionComponent, useCallback, useState } from 'react';
import { Dialogs } from '../../../dialogs';
import NavigationBar from '../navigation-bars/NavigationBar';
import { SideBar } from '../SideBar';
import { Footer } from '../Footer';
import { ScrollContainerProvider, useScrollContainer } from '../../../../utils/ScrollContainerContext';
import { PageLayoutProps } from './types';

// Section fills main so footer pins to the bottom and page content can use flex height.
const pageSectionStyle: React.CSSProperties = { flex: 1, minHeight: 0 };

export const PageLayout: FunctionComponent<PageLayoutProps> = (props) => (
  <ScrollContainerProvider>
    <PageLayoutContent {...props} />
  </ScrollContainerProvider>
);

const PageLayoutContent: FunctionComponent<PageLayoutProps> = ({
  aditionalNavbar,
  children,
  smallSidebar,
  externalLogicNavbar,
  showLoader,
  showHide,
}) => {
  const [sideBar, setSideBar] = useState(!!smallSidebar);
  const toggleSideBar = useCallback(() => {
    setSideBar((sBar) => !sBar);
  }, [setSideBar]);
  const { scrollContainerRef } = useScrollContainer();

  return (
    <>
      <main id="app-root" className={sideBar ? 'small-menu' : 'normal-menu'}>
        <SideBar />
        <section ref={scrollContainerRef} className="flex flex-column" style={pageSectionStyle}>
          {externalLogicNavbar ? (
            externalLogicNavbar
          ) : (
            <NavigationBar
              showLoader={showLoader}
              leftArrow={sideBar}
              toggleSideBar={toggleSideBar}
              showHide={showHide}
            />
          )}
          {showLoader === true ? null : aditionalNavbar}

          {children}
          <Footer />
        </section>
      </main>
      <Dialogs />
    </>
  );
};
